// extracted by mini-css-extract-plugin
module.exports = {"wrap":"zj-z","heading":"Aj-z"};